import { L } from '@lang';
import { Trans } from 'react-i18next';
import {
  IconAddSquare24,
  IconCheckOutline24,
  IconMoreVertical24,
  IconSmartphoneOutline24,
} from '../../../../shared/icons';
import { AppInfo } from '../../../../widgets/AppInfo';
import { InstallStep, installStepBoldClassName } from '../../../../widgets/InstallStep';
import { NativeGlassCard } from '../../../../widgets/NativeGlassCard';
import { NativeSeparator } from '../../../../widgets/NativeSeparator';
import styles from './InstallCard.module.css';

export function InstallCard() {
  return (
    <NativeGlassCard>
      <AppInfo title={L.t('pwa_install_yandex_app_title')} subtitle={L.t('pwa_install_yandex_app_subtitle')} />
      <NativeSeparator />
      <p className={styles.description}>{L.t('pwa_install_yandex_description')}</p>
      <NativeSeparator />
      <div className={styles.steps}>
        <InstallStep icon={<IconMoreVertical24 />}>
          <Trans
            i18n={L.i18n}
            i18nKey="pwa_install_yandex_menu_dots_title"
            components={{ b: <b className={installStepBoldClassName} /> }}
          />
        </InstallStep>
        <InstallStep icon={<IconSmartphoneOutline24 />}>
          <Trans
            i18n={L.i18n}
            i18nKey="pwa_install_yandex_add_shortcut_title"
            components={{ b: <b className={installStepBoldClassName} /> }}
          />
        </InstallStep>
        <InstallStep icon={<IconAddSquare24 />}>
          <Trans
            i18n={L.i18n}
            i18nKey="pwa_install_yandex_add_to_home_screen_title"
            components={{ b: <b className={installStepBoldClassName} /> }}
          />
        </InstallStep>
        <InstallStep icon={<IconCheckOutline24 />}>
          <Trans
            i18n={L.i18n}
            i18nKey="pwa_install_yandex_confirm_add_title"
            components={{ b: <b className={installStepBoldClassName} /> }}
          />
        </InstallStep>
      </div>
    </NativeGlassCard>
  );
}
